module.exports = __webpack_public_path__ + "img/login-bg.0899ffa6.jpg";